import heroImg from "../../assets/images/hero-img.png";
import { useState, useEffect } from "react";

export default function Hero() {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const titles = [
    "Lean Six Sigma Master Black Belt",
    "MBA",
    "Operations Management Specialist",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);

      // Wait for fade out animation to complete
      setTimeout(() => {
        setCurrentTextIndex((prevIndex) => (prevIndex + 1) % titles.length);
        setIsAnimating(false);
      }, 600); // Wait for fade out to complete
    }, 3000); // Changed back to 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <div className="container relative h-[800px] sm:h-[700px] pt-36 sm:pt-[124px] flex-col justify-start items-start flex">
        <img
          src={heroImg}
          alt="Image"
          className="right-0 bottom-0 absolute z-[0] sm:w-[50%]"
        />
        <div
          className="max-w-[664px] flex-col justify-start items-start gap-6 z-[1]"
          id="el_3_N_293_C_935"
        >
          <div className="flex-col justify-start items-start gap-2 flex">
            <div className="">
              <p className="text-[#0e0e0e] text-2xl md:text-5xl font-semibold font-primary md:leading-[62.40px]">
                Optimize Your{" "}
              </p>
              <p className="text-[#0075FF] text-2xl md:text-5xl font-semibold font-primary md:leading-[62.40px]">
                Industrial Operations
              </p>
              <p className="text-[#0e0e0e] text-2xl md:text-5xl font-semibold font-primary md:leading-[62.40px]">
                With Expert Lean Six Sigma Consulting
              </p>
            </div>
            <div className="justify-start items-center mb-4 inline-flex">
              <div className="max-w-[109px] py-2 justify-start items-center gap-2 flex">
                <p className="whitespace-nowrap text-[#0e0e0e] text-base font-normal font-primary leading-5">
                  Charles Bell: <br className="sm:hidden" />
                  <span
                    className={`inline-block ${
                      isAnimating ? "text-switch-exit" : "text-switch-enter"
                    }`}
                  >
                    {titles[currentTextIndex]}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <button
            onClick={() =>
              window.open(
                "https://calendly.com/charismaticconsultingar/",
                "_blank"
              )
            }
            className="p-3 bg-[#0075ff] hover:bg-[#0E0E0E] transition-all duration-300 rounded justify-center items-center gap-1.5 inline-flex"
          >
            <div className="whitespace-nowrap text-white text-base font-semibold font-primary leading-5">
              Schedule Your Free Consultation
            </div>
            <img
              src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Frame-a190596f-ea15-448e-bc9d-83838554fc03.svg"
              alt="Frame"
            />
          </button>
        </div>
      </div>
      <div className="w-full h-10 md:h-20 bg-[#0075FF]" />
    </div>
  );
}
